import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from "react-helmet-async";
/*
import 'bootstrap/dist/css/bootstrap.css';        // 1. Bootstrap
import './css/colors.css';                        // 2. Variables + thèmes
import './css/app.css';                           // 3. Styles généraux
import './index.css';                             // 4. Tailwind/reset/etc
*/


import './index.css';
import { Provider } from 'react-redux';
import store from './redux/redux';
import App from './App';
import reportWebVitals from './reportWebVitals';


createRoot(document.getElementById('root')).render(
  <HelmetProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </HelmetProvider>
);
reportWebVitals();





